export const MessageSecond = ({
  width = '24',
  height = '25',
  fill = 'none',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5 0.5C21.9853 0.5 24 2.51472 24 5V17C24 19.4853 21.9853 21.5 19.5 21.5H15.6213L13.0607 24.0607C12.4749 24.6464 11.5251 24.6464 10.9393 24.0607L8.37868 21.5H4.5C2.01472 21.5 0 19.4853 0 17V5C0 2.51472 2.01472 0.5 4.5 0.5H19.5ZM19.5 3.5H4.5C3.67157 3.5 3 4.17157 3 5V17C3 17.8284 3.67157 18.5 4.5 18.5H9C9.39782 18.5 9.77936 18.658 10.0607 18.9393L12 20.8787L13.9393 18.9393C14.2206 18.658 14.6022 18.5 15 18.5H19.5C20.3284 18.5 21 17.8284 21 17V5C21 4.17157 20.3284 3.5 19.5 3.5ZM16.5 12.5C17.3284 12.5 18 13.1716 18 14C18 14.8284 17.3284 15.5 16.5 15.5H7.5C6.67157 15.5 6 14.8284 6 14C6 13.1716 6.67157 12.5 7.5 12.5H16.5ZM16.5 6.5C17.3284 6.5 18 7.17157 18 8C18 8.82843 17.3284 9.5 16.5 9.5H7.5C6.67157 9.5 6 8.82843 6 8C6 7.17157 6.67157 6.5 7.5 6.5H16.5Z"
        fill="white"
      />
    </svg>
  );
};
